import { useContext } from 'react'
import classNames from 'classnames'

import slugify from 'scripts/utils/slugify'
import { onMenuClick } from 'scripts/utils/data-layer'

import DropdownProviderMethods from 'reactSite/Header/providers/DropdownProviderMethods'
import { HeaderContext } from 'reactSite/Header/contexts/HeaderContext'

import Children from '../common/children'
import DropdownArrow from './components/DropdownArrow'

const DesktopMenu = () => {
  const { dropdownElements, isBlackWeekend } = useContext(HeaderContext)

  const onItemClick = (event, item) => {
    event.preventDefault()

    onMenuClick({ item })

    const anchorElement = event.currentTarget.querySelector('a')
    const url = anchorElement.href

    window.location.href = url
  }

  const renderMenuItem = (item) => {
    const uniqueId = `${slugify(item.name)}-${item.id}`
    const itemClass = classNames('menu-item-title', {
      'is-store-menu': item.id === 'stores',
      'is-black-weekend': item.id === 'black-friday' && isBlackWeekend
    })

    return (
      <li className="menu-item" key={uniqueId} onClick={event => onItemClick(event, item)}>
        <a href={ item.url } className={itemClass}>
          { item.name }
          { item.content && <DropdownArrow />}
        </a>
        { item.content &&
          <ul className="menu-item-list menu-dropdown">
            <DropdownProviderMethods>
              <Children element={ item } />
            </DropdownProviderMethods>
          </ul>
        }
      </li>
    )
  }

  return (
    <ul className="menu-list">
      { dropdownElements &&
        dropdownElements.map(renderMenuItem)
      }
    </ul>
  )
}

export default DesktopMenu
